<template>
  <convenio-import />
</template>

<script>
import ConvenioImport from "@/modules/cobrox/components/ConvenioImport/ConvenioImport";

export default {
  name: "ConvenioImportPage",
  components: {ConvenioImport}
}
</script>

<style scoped>

</style>
